/**
 * Lightweight event tracking — fire-and-forget POST to /track.
 */

import { API_URL } from './config';
import { getAuthToken } from './auth';

export function trackEvent(event: 'citationClick' | 'timePanel'): void {
  getAuthToken(false).then(token => {
    if (!token) return;
    fetch(`${API_URL}/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ event }),
    }).catch(() => {}); // swallow errors
  });
}
